import React, { useEffect, useState } from 'react'
import { OnboardSelect } from '../../components/Onboard/OnboardComponents/Dropdown/Select';
import DatePickerHandle from '../../components/Onboard/OnboardComponents/KeyboardDatePicker';
import Filter_Icon from './../../assets/images/Filter_Icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { getHeatmapDropdownData, getHeatmapFormTableData, updateHeatmapFormDataStart } from '../../actions/Applications/heatmap.action';
import { Table } from 'react-bootstrap';
import AdminBreadcrumb from '../../components/Administration/General/Admin-breadcrumb';
import { useHistory } from 'react-router-dom';

const HeatmapForm = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const heatmapDropdownData = useSelector((state) => state.heatmapReducer.heatmapDropdownData)
    const heatmapFormTableData = useSelector((state) => state.heatmapReducer.heatmapFormTableData)


   const [servicedeskOptions, setServicedeskOptions] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [formData, setFormData] = useState([])
    const [isRefreshClicked, setIsRefreshedClicked] = useState(false);
    const [refreshCustomer, setRefreshCustomer] = useState(false);
  

    useEffect(() => {
        dispatch(getHeatmapDropdownData())
    }, [dispatch]);

   useEffect(() => {
  const serviceDeskId = formData?.ServiceDeskID;
  const customerId = formData?.CustomerName?.CustomerID;
  const toolId = formData?.Tool_Name?.ToolID;

  if (serviceDeskId || customerId || toolId) {
    dispatch(
      getHeatmapFormTableData(
        customerId ? customerId : '',
       toolId ? toolId : '',
       serviceDeskId ? serviceDeskId : '',
      )
    );
  }
}, [
  formData?.ServiceDeskID,
  formData?.CustomerName?.CustomerID,
  formData?.Tool_Name?.ToolID,
  dispatch
]);


   
    const toolOptions = heatmapDropdownData?.[0]?.Tools;
    const statusOptions = heatmapDropdownData?.[0]?.["Tool Status"];

    const allServiceDesks =
  heatmapDropdownData?.[0]?.Region?.flatMap(region =>
    region.Servicedesk || []
  ) || [];

  useEffect(() => {
  if (allServiceDesks.length > 0) {
    setServicedeskOptions(allServiceDesks);
  }
}, [heatmapDropdownData]);

   const handleServiceDeskChange = (name, servicedeskName, servicedeskId) => {
  const selectedDesk = servicedeskOptions.find(
    sd => sd.ServicedeskID === servicedeskId
  );

  setFormData(prev => ({
    ...prev,
    ServiceDeskID: servicedeskId
  }));

  if (selectedDesk) {
    setCustomerOptions(selectedDesk.Customer || []);
  } else {
    setCustomerOptions([]);
  }

  setRefreshCustomer(true);
};


    const addValueToFormData = (name, selectedOption) => {
        if (name !== 'Select') {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: selectedOption,
            }));
        }
    };

     function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [month, day, year].join('/');
  }
    const ValidFromDateHandler = (date) => {
        setFormData({ ...formData, 'ChangeDate': (date === null || date === undefined) ? null : formatDate(date) });
    }

    const submitHandler = () => {
        dispatch(updateHeatmapFormDataStart(
            [{"CustomerID":formData?.CustomerName?.CustomerID,
                "ToolID":formData?.Tool_Name?.ToolID,
                "StatusID":formData?.Status?.StatusID,
                "Notes":formData.comment,
                "ServiceDeskID":formData.ServiceDeskID,
                "StatusChangeDate":formData.ChangeDate}] , () =>{
                  dispatch(getHeatmapFormTableData('','',''))
                  resetHandler()
                }))

                
    }

    const resetHandler = () => {
  setFormData([]);
  setCustomerOptions([]);
  setIsRefreshedClicked(prev => !prev);
  setRefreshCustomer(prev => !prev);
};

const columns =
  heatmapFormTableData.length > 0
    ? Object.keys(heatmapFormTableData[0])
    : [];


    console.log('toolOptions', heatmapFormTableData)

    return (
        <div>
            <AdminBreadcrumb value1={()=>history.push('/applications')} label1='Applications' isActive2={true} value2={()=>history.push('/heatmap')} label2='HeatMap' isActive3={false} label3='HeatMap Form'/>

            <section className='App_Layout'>
                <div className='Applications_Title'> HeatMap Form </div>

            </section>
            <section className='Filter_aquaa'>
                <main className='aquaa_filter_img'>
                    <img src={Filter_Icon} alt='' style={{ padding: '20px', paddingTop: '70px', paddingLeft: '30px' }} />
                </main>
                <div className='aquaaFilterAlignment'>
                    <main className='Aquaa_dropdown'>
                        <label HtmlFor='country'>Country</label>
                        <OnboardSelect data={servicedeskOptions} name='Servicedesk' value='Servicedesk' id='ServicedeskID' marginTop='10px'
                            editValue='' addValueToQueue={handleServiceDeskChange} refresh={isRefreshClicked} />
                    </main>
                    <main className='Aquaa_dropdown'>
                        <label HtmlFor='country'>Account</label>
                        <OnboardSelect data={customerOptions} name='CustomerName' value='CustomerName' id='CustomerID' marginTop='10px'
                            editValue='' addValueToQueue={(key, value) => {
                                addValueToFormData(key, value);
                                setRefreshCustomer(false);
                            }} refresh={refreshCustomer} passFullObject={true} />
                    </main>

                    <main className='Aquaa_dropdown'>
                        <label HtmlFor='country'>Tool</label>
                        <OnboardSelect data={toolOptions} name='Tool_Name' value='Tool_Name' id='ToolID' marginTop='10px'
                            editValue='' addValueToQueue={(key, value) => {
                                addValueToFormData(key, value);
                                setIsRefreshedClicked(false);
                            }} refresh={isRefreshClicked} passFullObject={true} />
                    </main>
                    <main className='Aquaa_dropdown'>
                        <label HtmlFor='username'>Status</label>
                        <OnboardSelect data={statusOptions} name='Status' value='Status' id='StatusID' marginTop='10px'
                            editValue='' addValueToQueue={(key, value) => {
                                addValueToFormData(key, value);
                                setIsRefreshedClicked(false);
                            }} refresh={isRefreshClicked} passFullObject={true} />
                    </main>

                    <main className='Aquaa_dropdown'>
                        <DatePickerHandle
                         label='Valid From' id='label'  value={formData?.ChangeDate}
                        onChange={(date) => ValidFromDateHandler(date)}

                        />
                    </main>

                    <div className='TicketNoInput' >
                        <div><label>Comment</label></div>
                        <input
                            type="text"
                            style={{width:500}}
                            placeholder="Enter your Comment"
                            value={formData.comment || ''}
                            onChange={(e) => addValueToFormData('comment', e.target.value)}  
                        />
                    </div>

                    <button className='btn_adduser' onClick={() => {submitHandler() }}>SUBMIT</button>
                </div>
            </section>

            <section style={{ marginTop: '20px' }}>
            <div style={{ marginTop: "30px" }}>
  <Table bordered hover className="heatmap-table text-center align-middle mb-0">
    <thead className="table-secondary">
      <tr>
        {columns.map((col, index) => (
          <th key={index}>{(col)}</th>
        ))}
      </tr>
    </thead>

    <tbody>
      {heatmapFormTableData.length > 0 ? (
        heatmapFormTableData.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {columns.map((col, colIndex) => {
              let cellValue = row[col];

             
             if (col === "updateDate" && cellValue) {
  cellValue = formatDate(cellValue);
}

              return <td key={colIndex}>{cellValue}</td>;
            })}
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={columns.length} className="text-center">
            No Data Available
          </td>
        </tr>
      )}
    </tbody>
  </Table>
</div>

       </section>
       </div>
    )
}

export default HeatmapForm
